<template>
  <div class="surgeon" v-if="surgeon">
    <breadcrumbs :items="breadcrumbs">
      <div class="activation">
        <div class="surgeon-action">
          <rp-status :statusInfo="surgeon.activated_at"/>
        </div>

        <div class="surgeon-action">
          <rp-permissions :requireAll="['write_users']">
            <rp-button
              border-radius
              button-type="normal"
              @click="activateSurgeon">
              {{surgeonActive === 'Active' ? 'deactivate' : 'activate'}}
            </rp-button>
          </rp-permissions>
        </div>

        <div class="surgeon-action">
          <rp-permissions :requireAll="['write_users']">
            <router-link :to="{ name: 'edit-surgeon', params: { id: this.$route.params.id}}">
              <rp-sprite class="create-icon" name="create"/>
            </router-link>
            <rp-sprite @click.native="activeConfirm = !activeConfirm" class="create-icon" name="delete_outline" />
          </rp-permissions>
        </div>
      </div>
    </breadcrumbs>

    <div class="content">
      <div class="surgeon-info">
        <div class="info-group">
          <h3>Status</h3>
          <p>{{surgeonActive}}</p>
        </div>
        <div class="info-group">
          <h3>Title</h3>
          <p>{{surgeon.profile.salutation ? surgeon.profile.salutation : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>First Name</h3>
          <p>{{surgeon.profile.first_name ? surgeon.profile.first_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Last Name</h3>
          <p>{{surgeon.profile.last_name ? surgeon.profile.last_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Speciality</h3>
          <p>{{surgeon.profile.speciality ? surgeon.profile.speciality : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Email Address</h3>
          <p>{{surgeon.email ? surgeon.email : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Gender</h3>
          <p>{{surgeon.profile.gender | genderFilter}}</p>
        </div>
        <div class="table-container info-group" v-if="showData && surgeon.hospitals.length > 0">

          <h3>Hospitals:</h3>
          <rp-table
            :results="getHospitals"
            :key="update"
            noPagination
            :headings="[
              {heading: 'Hospital / Clinic', key: 'name'},
              'country',
              {heading: 'City', key: 'town'},
              {heading: 'Address', key: 'address_1'},
              {heading: 'Region', key: 'county'},
              {heading: 'disassociate', key: 'disassociate', button: true}]"
            @rowClick="onHospitalClick">
            <div
              v-for="(hospital, index) in surgeon['hospitals']"
              :key="index"
              :slot="'td-' + index + '-disassociate'">
              <span
                @click.stop="activeUnlinkDelete(hospital, 'hospital')">
                  <rp-sprite class="create-icon" name="disassociate"/>
              </span>
            </div>
          </rp-table>

        </div>
        <div class="table-container info-group" v-if="showData && surgeon.nurses.length > 0">
          
          <h3>Nurses:</h3>
          <rp-table
            name="users"
            :key="update"
            noPagination
            :results="getNurses"
            :headings="['name', 'email', 'gender', {heading: 'disassociate', key: 'disassociate', button: true}]"
            @rowClick="onNurseClick">
            <div
              v-for="(nurse, index) in surgeon['nurses']"
              :key="index"
              :slot="'td-' + index + '-disassociate'">
              <span
                @click.stop="activeUnlinkDelete(nurse, 'nurse')">
                  <rp-sprite class="create-icon" name="disassociate"/>
              </span>
            </div>
          </rp-table>

        </div>

      </div>
      
    </div>

    <rp-overlay :active="activeOverlay">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>

    <rp-overlay :active="activeConfirm">
      <rp-delete-confirm
        icon="warning"
        userType="Surgeon"
        messageType='Delete '
        :userName="userName"
        :cancel="cancelDeletion"
        :confirm="confirmDeletion" />
    </rp-overlay>

    <rp-overlay :active="activeDelete">
      <rp-alert
        icon="done"
        :message="alertMessage"
        :onClick="alertFunction" />
    </rp-overlay>

    <rp-overlay :active="activeUnlink">
      <rp-delete-confirm
        icon="warning"
        :messageText="disassociateConfirmText"
        :cancel="closeModal"
        :confirm="disassociateConfirmFunction"/>
    </rp-overlay>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import Status from 'raypro_ui/src/components/ui/Status'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Table from 'raypro_ui/src/components/ui/Table'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import {
  getUserDetails,
  activateUser,
  deactivateUser,
  deleteUser,
  removeHospitalFromSurgeon,
  removeNurseFromSurgeon
} from 'raypro_ui/src/api/users'
import DeleteConfirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import page from '@/mixins/page'
import Permissions from 'raypro_ui/src/components/Permissions'


export default {
  components: {
    Breadcrumbs,
    'rp-status': Status,
    'rp-button': Button,
    'rp-sprite': Sprite,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-delete-confirm': DeleteConfirm,
    'rp-table': Table,
    'rp-permissions': Permissions
  },

  data() {
    return {
      surgeon: null,
      activeOverlay: false,
      activeConfirm: false,
      activeDelete: false,
      title: 'Surgeon',
      showData: false,
      update: 0,
      activeUnlink: false,
      disassociateConfirmText: '',
      disassociateConfirmFunction: null,
      disassociateObject: null
    }
  },

  mixins: [page],

  methods: {
    // this is because I must pass the the function to the confirm, otherwise it would be one function
    activeUnlinkDelete(obj, type) {
      if(type === 'hospital') {
        this.disassociateConfirmText = `Unassociate hospital ${obj.name}`
        this.disassociateObject = obj
        this.disassociateConfirmFunction = this.disassociateHospital
      } else if(type === 'nurse') {
        this.disassociateConfirmText = `Unassociate nurse ${obj.profile.first_name} ${obj.profile.last_name}`
        this.disassociateObject = obj
        this.disassociateConfirmFunction = this.disassociateNurse
      }

      this.activeUnlink = !this.activeUnlink
    },

    closeModal() {
      this.activeUnlink = !this.activeUnlink
    },

    disassociateHospital() {
      const payload = {
        userId: this.surgeon.id,
        hospitalId: this.disassociateObject.id
      }

      removeHospitalFromSurgeon(payload).then(() => {
        this.getUser()
        this.closeModal()
      })
    },

    disassociateNurse() {
      const payload = {
        userId: this.surgeon.id,
        nurseId: this.disassociateObject.id
      }

      removeNurseFromSurgeon(payload).then(() => {
        this.getUser()
        this.closeModal()
      })
    },

    getUser() {
      getUserDetails(this.id).then(({data}) => {
        this.surgeon = data
        this.showData = true
        this.update++
      })
    },

    getHospitals() {
      return new Promise((resolve) => {
        const mapped = this.surgeon.hospitals.map((row) => {
          return {
            'id': row.id,
            'name': row.name,
            'country': row.country.name,
            'town': row.town,
            'address_1': row.address_1,
            'county': row.county
          }
        })

        resolve({
          data: mapped,
          page
        })
      })
    },

    getNurses() {
      return new Promise((resolve) => {
        const mapped = this.surgeon.nurses.map((row) => {
          return {
            id: row.id,
            name: `${row.profile.first_name} ${row.profile.last_name}`,
            email: row.email,
            // TODO: map to age group
            dob: row.profile.dob,
            gender: row.profile.gender
          }
        })

        resolve({
          data: mapped,
          page
        })
      })
    },

    onHospitalClick(row) {
      this.$router.push({name: 'view-hospital', params: {id: row.id}})
    },

    onNurseClick(row) {
      this.$router.push(`/nurses/${row.id}`)
    },

    successFunction() {
      this.activeOverlay = false
      this.getUser()
    },

    activateSurgeon() {
      if(this.surgeonActive === 'Active') {
        deactivateUser({id: this.id})
          .then(() => {
            this.activeOverlay = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      } else {
        activateUser({id: this.id})
          .then(() => {
            this.activeOverlay = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      }
    },

    alertFunction() {
      this.$router.push({name: 'all-users'})
    },

    cancelDeletion() {
      this.activeConfirm = !this.activeConfirm
    },

    confirmDeletion() {
      deleteUser({id: this.id})
        .then(() => {
          this.activeConfirm = !this.activeConfirm
          this.activeDelete = !this.activeDelete
        })
    }
  },

  mounted() {
    this.getUser()
  },

  filters: {
    genderFilter(gender) {
      if(gender === 'SURGEON DELETED') {
        return gender
      }
      if(gender === 'M') {
        return 'Male'
      }
      if(gender === 'F') {
        return 'Female'
      }
      if(gender === 'O') {
        return 'Prefer not to say'
      }

      return 'NOT PROVIDED'
    }
  },

  props: {id: String},

  watch: {
    id: function() {
      this.getUser()
    }
  },

  computed: {
    alertMessage() {
      return `Surgeon ${this.surgeon.profile.first_name} ${this.surgeon.profile.last_name} deleted successfully!`
    },

    salutation() {
      return this.surgeon.profile.salutation || ''
    },

    userName() {
      return `${this.surgeon.profile.first_name} ${this.surgeon.profile.last_name}`
    },

    currentBreadcrumb() {
      return `${this.salutation} ${this.userName}`
    },

    breadcrumbs() {
      return [
        {
          label: 'Surgeons',
          link: 'all-users'
        },
        {label: this.currentBreadcrumb}
      ]
    },

    surgeonActive() {
      return this.surgeon.activated_at ? 'Active' : 'Inactive'
    },

    successMessage() {
      return `Surgeon ${this.surgeonActive === 'Active' ? 'deactivated' : 'activated'} successfully!`
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.activation
  display: flex
  align-items: center
  justify-content: flex-end
  .surgeon-action
    margin-left: 15px
    .btn
      margin-top: 0px
      color: $color-text-invert
      border-color: $color-grey

.surgeon
  .content
    display: flex
    flex-direction: column
    @include media($media-medium)
      padding: 0 40px
      flex-direction: row
      justify-content: space-between
    .surgeon-info
      width: 100%
      .info-group
        display: flex
        flex-direction: column
        @include media($media-medium)
          flex-direction: row
          align-items: center
          width: 40%
        h3
          display: inline-flex
          width: 150px
          min-width: 150px
          margin: 0
          text-transform: initial
          font-weight: lighter
        p
          display: inline-flex
          line-height: 1
          font-weight: bold
          word-break: break-word

      .table-container
        flex-direction: column
        align-items: flex-start
        width: 100%
        h3
          margin: 15px 0
        .table
          margin-bottom: 15px
          width: 100%
      hr
        margin: 20px 0 36px
        border-top: 1px solid $color-grey-dark
    .modal-header
      padding: 20px
      font-size: 20px
      border-bottom: 2px solid #e2e4e4

    .modal-body
      min-height: 500px

</style>



// WEBPACK FOOTER //
// src/components/pages/Surgeons/Surgeon.vue